import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {MatButton} from "@angular/material/button";
import {MatDialog} from "@angular/material/dialog";
import {
  PipelinesFilterModalComponent
} from "./pipelines-subcomponents/pipelines-filter-modal/pipelines-filter-modal.component";
import {MatTooltip} from "@angular/material/tooltip";
import {MatIcon} from "@angular/material/icon";
import {
  PipelinesSelectionPanelComponent
} from "./pipelines-subcomponents/pipelines-selection-panel/pipelines-selection-panel.component";
import {PipelinesService} from "./pipelines.service";
import {AsyncPipe} from "@angular/common";
import PipelineViewFilter from "../interfaces/pipeline-view-filter";
import {
  ExportModalData,
  PipelinesExportModalComponent
} from "./pipelines-subcomponents/pipelines-export-modal/pipelines-export-modal.component";
import {PipelineExportService} from "./pipeline-export.service";
import{Subscription, combineLatest,lastValueFrom} from 'rxjs'
import PipelineView from "../interfaces/pipeline-view";
import PipelineFieldFilter from "../interfaces/pipeline-field-filter";
@Component({
  selector: 'app-pipelines',
  standalone: false,
  templateUrl: './pipelines.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './pipelines.component.scss',
})
export class PipelinesComponent implements OnInit{
  public filterId: string | null
  public showPipelinesSelectionList: boolean  = true;
  public isLoaded: boolean = false;

  public cachedDataSub:Subscription
  public cachedData:{pipeline_view_id: string | null, pipeline_view_filter_id: string | null, filter: any[] | string, sort: any[] | string, group: any[] | string} | null = null;
  public currentBaseView:PipelineView | null = null;
  public fields:PipelineFieldFilter[] = [];
  constructor(private router: ActivatedRoute, private dialog: MatDialog, public pipelineService: PipelinesService, public exportService:PipelineExportService) {
  }

  ngOnInit() {
    this.isLoaded = false;
    this.router.paramMap.subscribe(params => {
      this.filterId = params.get('filter')
      if(this.filterId!==null){
        this.showPipelinesSelectionList = false
      }
      this.pipelineService.getBaseViews()
      this.pipelineService.getPipelineViews()
      this.pipelineService.getPipelineFields()
      this.pipelineService.getFilteredPipeline({pipeline_view_filter_id: this.filterId}).subscribe({
        next: () => {this.isLoaded=true}
      })
      this.cachedDataSub = combineLatest({
        cachedData:this.pipelineService.cachedPipelineData$,
        currentBaseView: this.pipelineService.currentBaseView$,
        fields:this.pipelineService.exportFilters$,
      })
        .subscribe(
          ({cachedData, currentBaseView, fields}) => {
            this.cachedData = cachedData
            this.currentBaseView = currentBaseView
            this.fields = fields;
          }
        )
    })
  }

  public openFilterModal(){
    let dialogRef = this.dialog.open(PipelinesFilterModalComponent, {
      width: "1200px",
      data: {
        pipeline: this.pipelineService['_cachedPipelineData']
      }
    })
  }

  public openExportModal(){
    let data: ExportModalData|null = null;
    if(this.currentBaseView){
      data={
        fields:this.fields,
        dataStore: this.cachedData,
        currentView: this.currentBaseView
        }
    }
    if(data) {
      let dialogRef = this.dialog.open(PipelinesExportModalComponent, {
        width: "1000px",
        data
      })
    }
  }

  public showHidePipelinesList(){
    this.showPipelinesSelectionList = !this.showPipelinesSelectionList;
  }

  public refreshPipelineData(){
    this.pipelineService.refreshFilteredPipeline().subscribe({
      next: () => { this.isLoaded = true}
    })
  }


  public quickExport(){
    this.exportService.quickExport(this.cachedData, this.currentBaseView, this.fields)
  }
  ngOnDestroy() {
    this.cachedDataSub?.unsubscribe();
  }
}
